import type {ModalDialogService} from 'shared/modal-dialogs';
import type {FieldsDefinitionsDataService} from 'src/features/record-editation/field7-and-field8-editors/fields-definitions-data.service';
import type {
    AuthorityField8EditorModalModel
} from 'src/features/record-editation/field7-and-field8-editors/authority-field8-editor-modal/types';

export class AuthorityField8ValueEditorService {
    public static serviceName = 'authorityField8ValueEditorService';


    /*@ngInject*/
    constructor(private modalDialogService: ModalDialogService, private fieldsDefinitionsDataService: FieldsDefinitionsDataService) {
    }

    public async editModelFunction(model: string): Promise<string> {
        const definitions = await this.fieldsDefinitionsDataService.getAuthorityField008Definitions();

        const modalModel: AuthorityField8EditorModalModel = {value: model, definitions};
        return this.modalDialogService.openModalWindowAndGetPayload('authorityField8Editor', modalModel);
    }
}

